export default __webpack_public_path__ + "static/media/cypat-bg.a0453a2b.webp";